import http from "src/_services/httpService";

import { $BASE_URL, ROLES, USER_ROLES } from "src/constants";
const apiUrl = $BASE_URL + '/api';

const apiEndpoints = {
    [ROLES.admin]: apiUrl + "/v1/admin-panel/driver",
    [ROLES.merchant]: apiUrl + "/v1/merchant-dashboard/driver",
    [ROLES.shippingCompany]: apiUrl + "/v1/merchant-dashboard/driver",
    [USER_ROLES.MERCHANT]: apiUrl + "/v1/merchant-dashboard/driver",
}

function driverUrl(role, id) {
    return `${apiEndpoints[role]}/${id}`;
}

const createDriver = (role, driver) => {
    return http.post(apiEndpoints[role], driver);
}

const getDrivers = (role) => {
    return http.get(apiEndpoints[role]);
}

const getDriver = (role, driverId) => {
    return http.get(driverUrl(role, driverId));
}

const updateDriver = (role, driverId, driver) => {
    return http.put(driverUrl(role, driverId), driver);
}

const resetDriverPassword = (role, driverId, credentials) => {
    const url = `${apiEndpoints[role]}/update-password/${driverId}`
    return http.put(url, credentials);
}

const settleDriverBalance = (role, driverId) => {
    const url = `${apiEndpoints[role]}/settle-balance/${driverId}`
    return http.put(url);
}

const downloadBalanceReport = (role, driverId, email) => {
    const url = `${apiEndpoints[role]}/xlsx/${driverId}?email=${email}`;
    return http.get(url)
}

const deleteDriver = (role, driverId) => {
    return http.delete(driverUrl(role, driverId));
}

const getDriversBySearch = (text) => {
    return http.get(`${apiUrl}/v1/driver?searchKey=${text}`);
}

const getAllDrivers = () => {
    return http.get(`${$BASE_URL}/api/v1/driver/search`);
}
const getDriversForWarehouse = () => {
    return http.get(`${$BASE_URL}/api/v1/driver`);
}

const DriverService =  {
    createDriver,
    getDrivers,
    getDriver,
    updateDriver,
    deleteDriver,
    resetDriverPassword,
    settleDriverBalance,
    downloadBalanceReport,
    getDriversBySearch,
    getAllDrivers,
    getDriversForWarehouse
};

export default DriverService;
